<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recuperação de senha</h4>
                                    <p>Por favor, insira seu email e nós enviaremos as instruções para recuperação de senha.</p>
                                </div>

                                <vs-input type="email" label-placeholder="Email" v-model="email" class="w-full mb-8" />
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Voltar para Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="recoverPassword">Recuperar senha</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    recoverPassword () {
      return fetch('http://187.122.106.24:6347', {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'reset_password',
          parameters: {
            application_token: 'c02da7cc-ceaf-43ac-93ad-1f8270867e58',
            username: this.email
          }
        })
      })
        .then((response) => {
          this.$vs.notify({
            title: 'Email encaminhado!',
            text: `Encaminhamos um email para ${this.email} com as instruções de recuperação de senha!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Email encaminhado!',
            text: `Encaminhamos um email para ${this.email} com as instruções de recuperação de senha!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
        })
    }
  }
}
</script>
